import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import filterReducer from "./slices/filterSlice";
import settingReducer from "./slices/settingSlice";
import { api } from "./api";

const rootReducer = combineReducers({
  auth: authReducer,
  filters: filterReducer,
  setting: settingReducer,
  [api.reducerPath]: api.reducer,
});

export default rootReducer;
